import { IconCcAmex } from '@lightspeed/flame/Icon/CcAmex';
import { IconCcDinersClub } from '@lightspeed/flame/Icon/CcDinersClub';
import { IconCcDiscover } from '@lightspeed/flame/Icon/CcDiscover';
import { IconCcGeneric } from '@lightspeed/flame/Icon/CcGeneric';
import { IconCcInterac } from '@lightspeed/flame/Icon/CcInterac';
import { IconCcJcb } from '@lightspeed/flame/Icon/CcJcb';
import { IconCcMastercard } from '@lightspeed/flame/Icon/CcMastercard';
import { IconCcUnionPay } from '@lightspeed/flame/Icon/CcUnionPay';
import { IconCcVisa } from '@lightspeed/flame/Icon/CcVisa';

import { IconCheckingAccount } from './IconCheckingAccount';

export default function getCardBrandIcon(brand: string) {
  switch (brand.toLowerCase()) {
    case 'amex':
      return IconCcAmex;
    case 'diners':
      return IconCcDinersClub;
    case 'discover':
      return IconCcDiscover;
    case 'generic':
      return IconCcGeneric;
    case 'interac':
      return IconCcInterac;
    case 'jcb':
      return IconCcJcb;
    case 'mastercard':
      return IconCcMastercard;
    case 'unionpay':
      return IconCcUnionPay;
    case 'visa':
      return IconCcVisa;
    case 'us_bank_account':
      return IconCheckingAccount; // Custom bank icon for checking accounts
    default:
      return IconCcGeneric; // Fallback to a generic icon if brand is unknown
  }
}
